import {Component, HostBinding} from "@angular/core";

@Component({
    selector: "fui-canvas-masthead",
    styleUrls: ["./canvas-masthead.component.scss"],
    templateUrl: "./canvas-masthead.component.html",
    standalone: false
})
export class FUICanvasMastheadComponent {
    @HostBinding("attr.tabIndex") public tabIndex: number = 1;
}
